import * as React from 'react';
import { Add, Eye, EyeOff } from '../../Icon/icon';
import { ItemType } from '../../../enums/ItemType';
import { Resource } from '../../../enums/Resource';
import AccessControl from '../../AccessControl/accessControl';
import { Metadata } from '../../../types/Metadata';

type AudienceMetadataButtonsProps = {
  isAllMetadataVisible: boolean;
  setAllMetadataVisible: (visible: boolean) => void;
  isAdditionalQuestionsVisible: boolean;
  setAdditionalQuestionsVisible: (visible: boolean) => void;
  itemType?: string;
  isModal?: boolean;
  onAddAdditionalQuestions?: () => void;
  addQuestionsButtonText?: string;
  data?: Partial<Metadata>;
};

export const AudienceMetadataButtons = ({
  isAllMetadataVisible,
  setAllMetadataVisible,
  isAdditionalQuestionsVisible,
  setAdditionalQuestionsVisible,
  itemType,
  isModal = false,
  onAddAdditionalQuestions,
  addQuestionsButtonText = 'Add More Question(s)',
  data
}: AudienceMetadataButtonsProps) => {
  const handleHideMetadata = () => {
    setAllMetadataVisible(false);
    setAdditionalQuestionsVisible(false);
  };

  return (
    <>
      {isAllMetadataVisible && !isModal && (
        <div className="audience-metadata-buttons-container">
          <div className="see-all-metadata-button">
            <span
              className="see-all-metadata-text"
              onClick={handleHideMetadata}
            >
              <EyeOff />
              Hide Audience Metadata
            </span>
          </div>
          {itemType === ItemType.content && (
            <AccessControl resource={Resource.updateAudiences} data={data}>
              <div className="see-all-metadata-button">
                <span
                  className="see-all-metadata-text"
                  onClick={
                    onAddAdditionalQuestions
                      ? onAddAdditionalQuestions
                      : () => setAdditionalQuestionsVisible(true)
                  }
                >
                  <Add />
                  {addQuestionsButtonText}
                </span>
              </div>
            </AccessControl>
          )}
        </div>
      )}
      {!isAllMetadataVisible && !isAdditionalQuestionsVisible && (
        <div className="audience-metadata-buttons-container">
          {!isModal && (
            <div className="see-all-metadata-button">
              <span
                className="see-all-metadata-text"
                onClick={() => setAllMetadataVisible(true)}
              >
                <Eye />
                See All Audience Metadata
              </span>
            </div>
          )}
          {itemType === ItemType.content && (
            <AccessControl resource={Resource.updateAudiences} data={data}>
              <div className="see-all-metadata-button">
                <span
                  className="see-all-metadata-text"
                  onClick={
                    onAddAdditionalQuestions
                      ? onAddAdditionalQuestions
                      : () => setAdditionalQuestionsVisible(true)
                  }
                >
                  <Add />
                  {addQuestionsButtonText}
                </span>
              </div>
            </AccessControl>
          )}
        </div>
      )}
      {!isAllMetadataVisible &&
        isAdditionalQuestionsVisible &&
        itemType === ItemType.content && (
          <div className="audience-metadata-buttons-container">
            {!isModal && (
              <div className="see-all-metadata-button">
                <span
                  className="see-all-metadata-text"
                  onClick={() => setAllMetadataVisible(true)}
                >
                  <Eye />
                  See All Audience Metadata
                </span>
              </div>
            )}
            <div className="see-all-metadata-button">
              <span
                className="see-all-metadata-text"
                onClick={() => setAdditionalQuestionsVisible(false)}
              >
                <EyeOff />
                Hide Additional Question(s)
              </span>
            </div>
          </div>
        )}
    </>
  );
};
